<template>
  <div id="login">
    <el-dialog :visible.sync="global.isLogin"
               width="35%"
               custom-class="custom-dialog"
               :show-close="false"
               :close-on-press-escape="false">
      <div class="login-title">
        <div class="login-text"
        :class="isLogin ? 'login-center-text':''"
        @click="isLogin = true">登录</div>
        <div class="login-hr"></div>
        <div class="login-text"
        :class="!isLogin ? 'login-center-text':''"
        @click="isLogin = false">注册</div>
      </div>
      <div v-if="isLogin">
        <div class="login-select">
          <div class="login-select-text"
              @click="isType = 'weixin'"
              :class="isType === 'weixin' ? 'login-center-text':''">微信扫码</div>
          <div class="login-hr"></div>
          <div class="login-select-text"
              @click="isType = 'iphone'"
              :class="isType === 'iphone' ? 'login-center-text':''">手机验证码</div>
          <div class="login-hr"></div>
          <div class="login-select-text"
              @click="isType = 'account'"
              :class="isType === 'account' ? 'login-center-text':''">账号密码</div>
        </div>
        <div class="login-center">
          <weixin v-if="isType === 'weixin'"></weixin>
          <iponeLogin v-if="isType === 'iphone'"></iponeLogin>
          <account v-if="isType === 'account'"></account>
        </div>
      </div>
      <div v-if="!isLogin">
        <!-- <div class="login-select">
          <div class="login-select-text"
              
              :class="isRegister === 'weixin' ? 'login-center-text':''">微信扫码注册</div>
          <div class="login-hr"></div>
          <div class="login-select-text"
              @click="isRegister = 'account'"
              :class="isRegister === 'account' ? 'login-center-text':''">账号密码注册</div>
        </div> -->
        <div class="login-center1">
          <accountRegister v-if="isRegister === 'account'"></accountRegister>
        </div>
      </div>
    </el-dialog>


  </div>
</template>

<script>
import weixin from '@/components/login/weixin.vue'
import iponeLogin from '@/components/login/iphone-login.vue'
import account from '@/components/login/account.vue'
import accountRegister from '@/components/login/accountRegister.vue'
export default {
  name: 'HgOnlineLogin',
  components: {
    weixin,
    iponeLogin,
    account,
    accountRegister,
  },
  data() {
    return {
      isType: 'account',
      // 登录注册切换
      isLogin: true,
      isRegister: 'account',
    }
  },
computed: {
},
  mounted() {},

  methods: {}
}
</script>

<style scoped>
#login {
  width: 100%;
  height: 100%;
}
::v-deep .el-dialog {
  height: 6rem;
  border-radius: 0.1rem;
}
::v-deep .el-dialog__header {
  padding: 0;
  margin: 0;
}
::v-deep .el-dialog__body {
  padding: 0;
  margin: 0;
}
.login-title {
  width: 100%;
  height: 0.7rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 0.4rem;
}
.login-select {
  width: 70%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin: 0 auto;
  padding-top: 0.1rem;
}
.login-text {
  padding: 0.1rem;
  font-weight: 700;
  font-size: 0.25rem;
  color: black;
}
.login-select-text {
  font-size: 0.2rem;
  color: black;
}
.login-hr {
  width: 0.01rem;
  height: 0.3rem;
  background-color: black;
}
.login-center {
  height: 3.3rem;
  width: 100%;
  margin-top: 0.5rem;
}
.login-center1 {
  height: 4.5rem;
  width: 100%;
  /* margin-top: 0.2rem; */
}
.login-center-text {
  color: #0059ab;
}

</style>